const GET_DATA_USAGE_STATUS = 'usage-status/GET_DATA_USAGE_STATUS';
const SET_USAGE_STATUS = 'usage-status/SET_USAGE_STATUS';
const SET_DATA_USAGE_STATUS = 'usage-status/SET_DATA_USAGE_STATUS';

export default {
  GET_DATA_USAGE_STATUS,
  SET_USAGE_STATUS,
  SET_DATA_USAGE_STATUS,
};
